export const filterApi = event => {
  const apiParameters = JSON.parse(event);
  let apiRequest = null;
  let apiResponse = null;
  if (apiParameters?.order_api_data !== undefined) {
    const orderApiData = apiParameters?.order_api_data;
    if (orderApiData?.request !== undefined) {
      apiRequest = orderApiData.request;
    }
    if (orderApiData?.response !== undefined) {
      apiResponse = orderApiData.response;
    }
  } else if (apiParameters?.refund_api_data !== undefined) {
    const refundApiData = apiParameters?.refund_api_data;
    if (refundApiData?.request !== undefined) {
      apiRequest = refundApiData.request;
    }
    if (refundApiData?.response !== undefined) {
      apiResponse = refundApiData.response;
    }
  }
  if (apiParameters?.charge_api_data !== undefined) {
    const chargeApiData = apiParameters?.charge_api_data;
    if (chargeApiData?.request !== undefined) {
      apiRequest = chargeApiData.request;
    }
    if (chargeApiData?.response !== undefined) {
      apiResponse = chargeApiData.response;
    }
  }
  if (
    [
      "The payment request has just started",
      "Payment request API has just started"
    ].includes(apiParameters?.message)
  ) {
    apiRequest = apiParameters;
  }
  if (
    [
      "Response of the payment api request",
      "Payment request API response"
    ].includes(apiParameters?.message)
  ) {
    apiResponse = apiParameters;
  }

  return {
    apiRequest,
    apiResponse
  };
};

export const getTimestamp = timestamp => {
  const date = new Date(timestamp);

  const timestampOptions = { hour12: false, timeZone: "Asia/Manila" };
  const localTime = date.toLocaleString("en-US", timestampOptions);

  return localTime;
};
